/* ============================================================
   BlendWave — Home JavaScript
   Reveal-on-scroll, variant colour switching, mobile nav
   drawer, and smooth anchor scrolling.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Reveal on scroll (IntersectionObserver, with fallback) ──
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length > 0) {
    const io = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

    function checkReveals() {
      revealEls.forEach(el => {
        if (el.classList.contains('visible')) return;
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('visible');
          if (io) io.unobserve(el);
        }
      });
    }

    // Reveal anything already in (or near) the viewport immediately.
    revealEls.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('visible');
      } else if (io) {
        io.observe(el);
      }
    });

    // Fallback for throttled/unavailable observers.
    window.addEventListener('scroll', checkReveals, { passive: true });
    window.addEventListener('resize', checkReveals, { passive: true });
  }

  // ── Colour / variant switching ─────────────
  const colorBtns   = document.querySelectorAll('.color-btn');
  const variantImgs = document.querySelectorAll('.variant-img');
  const colorLabel  = document.getElementById('color-label');
  const shopBtn     = document.getElementById('shop-color-btn');

  if (colorBtns.length > 0) {
    colorBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const variantId    = btn.dataset.variantId;
        const variantTitle = btn.dataset.variantTitle;

        colorBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        variantImgs.forEach(img => {
          img.classList.toggle('active', img.dataset.variantId === variantId);
        });

        if (colorLabel && variantTitle) {
          colorLabel.textContent = variantTitle;
        }

        if (shopBtn && variantId) {
          const baseUrl = shopBtn.getAttribute('data-base-url') || shopBtn.getAttribute('href').split('?')[0];
          shopBtn.setAttribute('href', baseUrl + '?variant=' + variantId);
        }
      });
    });
  }

  // ── Mobile nav drawer ────────────────
  const hamburger   = document.querySelector('.nav-hamburger');
  const drawer      = document.querySelector('.nav-drawer');
  const drawerClose = document.querySelector('.nav-drawer-close');
  const overlay     = document.querySelector('.nav-overlay');

  function openDrawer() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('no-scroll');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      if (drawer.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (drawer) {
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
  });

  // ── Smooth anchor scroll ─────────────
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  // ── Sticky nav scrolled state ─────────────
  const nav = document.querySelector('.nav');
  if (nav) {
    function checkNavScroll() {
      nav.classList.toggle('scrolled', window.scrollY > 12);
    }
    checkNavScroll();
    window.addEventListener('scroll', checkNavScroll, { passive: true });
  }

  // ── Announcement bar dismiss ──────────────────────────
  // Back to a normal in-flow bar under the nav — see
  // announcement-banner.liquid. Just needs a close button that
  // collapses it; no delayed reveal since it's part of the page
  // layout now, not a floating popup.
  const announcementBar = document.getElementById('announcementBar');
  if (announcementBar) {
    const closeBtn = announcementBar.querySelector('.announcement-bar-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        announcementBar.classList.add('dismissed');
      });
    }
  }

  // ── Subtle product image tilt on pointer move ───────────
  const tiltTarget = document.querySelector('.cta-visual');
  if (tiltTarget) {
    const img = tiltTarget.querySelector('.cta-image');
    if (img) {
      tiltTarget.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'touch') return;
        const rect = tiltTarget.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = `rotateY(${x * 10}deg) rotateX(${y * -10}deg)`;
      });

      tiltTarget.addEventListener('pointerleave', () => {
        img.style.transform = '';
      });
    }
  }

});
